import { DocumentAnswer, DocumentVersion } from "@models";
import { TemplateQuestion } from "@types";
import { useUpdateSearchParams } from "@utils";
import { isStepComplete } from "src/utils/step";
import {
  ProgressBubbleBar,
  type ProgressBubbleItem,
} from "./ProgressBubbleBar";

export const ProgressBubbles = ({
  filteredSteps,
  activeStep,
  documentVersion,
}: {
  filteredSteps: TemplateQuestion[];
  activeStep: TemplateQuestion;
  documentVersion: DocumentVersion;
}) => {
  const updateSearchParams = useUpdateSearchParams();
  const progressSteps = filteredSteps.map<ProgressBubbleItem>((step, index) => {
    const enabled =
      documentVersion.answers.find(
        (a: DocumentAnswer) =>
          a.element === filteredSteps[index - 1]?.id &&
          isStepComplete(filteredSteps[index - 1], a)
      ) || index === 0;
    const completed = documentVersion.answers.find(
      (a: DocumentAnswer) => a.element === step.id && isStepComplete(step, a)
    );

    return {
      id: step.id,
      label: `Step ${index + 1}`,
      status:
        step.id === activeStep.id
          ? "active"
          : completed
            ? "completed"
            : "pending",
      enabled: !!enabled,
    };
  });

  return (
    <ProgressBubbleBar
      steps={progressSteps}
      ariaLabel="Wizard progress"
      onStepClick={(stepId) => updateSearchParams({ step: stepId })}
    />
  );
};
